import * as React from 'react';
import { BookingSystemCriteria } from 'app/pages/DiscountEditor/modules/AdditionalCriteria';
import BookingSystemCriteriaModal from 'app/pages/DiscountEditor/components/AdditionalCriteriaEditor/BookingSystemCriteriaModal';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';

interface BookingSystemCriteriaDisplayProps {
    onEdit: () => void
    onDelete: () => void
    criteria: BookingSystemCriteria
}

export default function BookingSystemCriteriaDisplay(props: BookingSystemCriteriaDisplayProps) {
    if (!props.criteria.hasCriteria)
        return <div><BookingSystemCriteriaModal /></div>;
    
    const description = "Discount only available to the following booking systems: " + 
        props.criteria.selectedSystems.map(x => x.name).join(', ');
    
    return <div>
            <BookingSystemCriteriaModal />
            <div style={{ marginBottom: 16 }}>
                <div style={{ fontWeight: 600, marginBottom: 8, fontSize: 14 }}>Booking system</div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ flex: 1 }}>
                        {description}
                    </div>
                    <div style={{ display: 'flex', gap: 4 }}>
                        <Button 
                            type="text"
                            icon={<DeleteOutlined />}
                            onClick={() => props.onDelete()}
                            style={{ padding: '4px 8px' }}
                        />
                        <Button 
                            type="text"
                            icon={<EditOutlined />}
                            onClick={() => props.onEdit()}
                            style={{ padding: '4px 8px' }}
                        />
                    </div>
                </div>
            </div>
        </div>
}